// src/PrivacyPolicy.js
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto bg-white p-6 shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Comparison Guru LTD Privacy Policy</h1>
        
        <h2 className="text-2xl font-bold mb-4 text-gray-800">About This Privacy Policy</h2>
        <p className="text-lg text-gray-700 mb-4">
        Our Privacy Policy sets out how we will use and share the information that you give
us. The General Data Protection Regulation (GDPR) describes how organisations
must collect, handle, process and store personal information. These rules apply
regardless of whether data is stored electronically, on paper or on other materials. To
comply with the law, personal information must be collected and used fairly, stored
safely and not disclosed unlawfully.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We take your privacy seriously and will only use your personal information in accordance with the law. We will never sell, share, or use your personal information other than as described here and/or as explained when we collect your data.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Who We Are And How To Contact Us</h2>
        <p className="text-lg text-gray-700 mb-4">
        COMPARISON GURU LTD connects people who are looking for information and a
quote for a product or service with relevant providers. The Company is registered in
the United Kingdom. You can contact us in any of the following ways:
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Email: <a href="mailto:hello@comparison-guru.co.uk" className="text-blue-600 underline">hello@comparison-guru.co.uk</a><br/>
          Website: <a href="https://comparison-guru.co.uk" className="text-blue-600 underline">https://comparison-guru.co.uk</a>
        </p>
        <p className="text-lg text-gray-700 mb-4">
        COMPARISON GURU LTD is the Data Controller, we have a legal responsibility for
how that information is stored and processed. In some situations, we are Joint Data
Controller with our partner. We will ensure that we have appropriate Data Sharing
Agreements in place to clearly define roles and responsibilities when processing
your data.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Frequently Asked Questions</h2>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">How will my data be used?</h3>
        <p className="text-lg text-gray-700 mb-4">
        Only with your consent via the opt-in notice when you search for a deal with us,
COMPARISON GURU LTD will collect your data securely on our website and may
contact you to confirm by phone, SMS, Email or the chat on our website to confirm
some details or product requirements. We may also contact you to ask about your
experience using our site or service.
        </p>
        <p className="text-lg text-gray-700 mb-4">
        Again, only with your consent, your data may also be shared with marketing partners
        to provide marketing services (see below).
        </p>
        <p className="text-lg text-gray-700 mb-4">
        When you enter your details on our website, we will pass your request onto one of
our partners who will contact you about the relevant product or service you have
requested. Our partners will use your personal data to obtain a quote for the product
or service requested.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">What data will be stored?</h3>
        <p className="text-lg text-gray-700 mb-4">
        We will store your personal details in order to respond to your request. The data
stored would typically include your name and/or business name, address, email
address, phone number and details about the product or service you are looking for.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">What data will be shared?</h3>
        <p className="text-lg text-gray-700 mb-4">
        With your consent, we will share your data with our partners to provide a quote for
the product or service that you requested information about and as explained when
we collect your data. We may need to share your information with any regulator or
legal body that requests it.
        </p>
        <p className="text-lg text-gray-700 mb-4">
        We will get your consent before sending third party direct marketing communications
to you via email or text message. You have the right to withdraw consent to
marketing at any time by contacting us.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">How long will you store my data?</h3>
        <p className="text-lg text-gray-700 mb-4">
        We will only retain your personal data for as long as reasonably necessary to fulfil
the purposes we collected it for, including for the purposes of satisfying any legal,
regulatory, tax, accounting or reporting requirements. We may retain your personal
data for a longer period in the event of a complaint or if we reasonably believe there
is a prospect of litigation in respect to our relationship with you.
        </p>
        <p className="text-lg text-gray-700 mb-4">
        To determine the appropriate retention period for personal data, we consider the
amount, nature and sensitivity of the personal data, the potential risk of harm from
unauthorised use or disclosure of your personal data, the purposes for which we
process your personal data and whether we can achieve those purposes through
other means, and the applicable legal, regulatory, tax, accounting or other
requirements.
        </p>
        <p className="text-lg text-gray-700 mb-4">
            Your data will be stored as explained in our Data Retention Document.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">Who can access my data?</h3>
        <p className="text-lg text-gray-700 mb-4">
        Access to your data is carefully controlled and access will be limited to only
        authorised personnel.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">How is my data kept secure?</h3>
        <p className="text-lg text-gray-700 mb-4">
        We will store your data on secure UK based servers. We use industry approved
security protocols/technology to secure data at all times. Our Information Security
policy explains this in more detail, if you wish to see a copy, please contact us.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">Who does our Privacy Policy apply to?</h3>
        <p className="text-lg text-gray-700 mb-4">
          COMPARISON GURU LTD is a marketing company. Processing of your data is required in order to run our company and our marketing services.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          This policy applies to individuals who have shared their data with COMPARISON GURU LTD in any capacity, and to individuals whose data we have collected as part of providing our own Marketing operation.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          It applies to all data that the company holds relating to identifiable individuals, even if that information technically falls outside of the GDPR. This can include:
        </p>
        <ul className="list-disc pl-5 text-lg text-gray-700 mb-4">
          <li>Names of Individuals</li>
          <li>Postal addresses</li>
          <li>Email Addresses</li>
          <li>Telephone numbers</li>
          <li>Personal information</li>
          <li>Financial information</li>
          <li>Technical information about devices, sites, ip address, and use of the internet</li>
          <li>Other information as required to provide our services and operate our company</li>
        </ul> 

        <h3 className="text-xl font-semibold mb-2 text-gray-800">How will we use your data?</h3>
        <p className="text-lg text-gray-700 mb-4">
          This section describes the lawful basis for processing data and applies to information about individuals that we collect, store, or process for all sources. This includes:
        </p>
        <ul className="list-disc pl-5 text-lg text-gray-700 mb-4">
          <li>The Information you provide when you contact us</li>
          <li>When you contact us in order to discuss the products and services we offer</li>
          <li>Information we collect about how you use the website, apps, the internet, or other online properties</li>
          <li>Information that is given and stored as part of any ongoing relationship</li>
          <li>Information we collect as part of our marketing operation</li>
        </ul> 
        <p className="text-lg text-gray-700 mb-4">
          We do not routinely collect or process sensitive data, where this occurs we will take appropriate precautions with this data, including asking for your explicit consent to process any such sensitive data.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We will only use your personal data for the purposes for which we collected it and as you would reasonably expect your data to be processed and only where there is a lawful basis for such processing. Here are some examples of how your data is processed.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">When you provide your details to us</h3>
        <p className="text-lg text-gray-700 mb-4">
          Types of data collected: Identity, Contact, Personal Information
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing: Performance of a contract with you, with your consent, and/or in our legitimate interest of the interests of a third-party
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">To process and deliver the services you request including managing payments, fees, and charges, and to collect and recover money owed to us</h3>
        <p className="text-lg text-gray-700 mb-4">
          Types of data collected: Identity, Contact, Financial, Transaction, Marketing & Communications
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing: Performance of a contract with you and Necessary for our legitimate interests to recover debts owed to us
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">To manage our ongoing relationship with you which will include notifying you about other products and services, changes to our terms or privacy policy, to maintain our records</h3>
        <p className="text-lg text-gray-700 mb-4">
          Types of data collected: Identity, Contact, Profile, Marketing & Communications
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing: Performance of a contract with you, Necessary to comply with a legal obligation and Necessary for our legitimate interests to keep our records updated and to study how customers use our services, with your consent
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">To administer, protect our business and our site (including troubleshooting, data analysis, testing, system maintenance, support, reporting and hosting of data)</h3>
        <p className="text-lg text-gray-700 mb-4">
          Types of data collected: Identity, Contact, Technical
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing: Necessary for our legitimate interests for running our business, provision of administration and IT services, network security, to prevent fraud and in the context of a business reorganisation or group restructuring exercise, Necessary to comply with a legal obligation, with your consent
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">
          To deliver relevant content and advertisements to you and measure and understand the effectiveness of our advertising
        </h3>
        <p className="text-lg text-gray-700 mb-4">
          Types of data collected: Identity, Contact, Profile, Usage, Marketing & Communication, Technical
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing: Necessary for our legitimate interests to study how customers use our services, to develop them, to grow our business and to inform our marketing strategy
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">
          To use data analytics to improve our website, services, marketing, customer relationships and experiences
        </h3>
        <p className="text-lg text-gray-700 mb-4">
          Types of data collected: Technical, Usage
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing: Necessary for our legitimate interests to define types of customers for our services, to keep our site updated and relevant, to develop our business and to inform our marketing strategy
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">
          To make suggestions and recommendations to you about products and services that may be of interest to you
        </h3>
        <p className="text-lg text-gray-700 mb-4">
          Types of data collected: Identity, Contact, Technical, Usage, Profile
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing: Necessary for our legitimate interests to develop our services and grow our business
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">
          To operate our Marketing company and provide our services to our Business Partners
        </h3>
        <p className="text-lg text-gray-700 mb-4">
          Types of data collected: Identity, Contact, Financial, Life style, Professional, Technical, Other information as required
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing: Necessary for our legitimate interests and the legitimate interests of our clients to develop services and grow our businesses
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">To create custom and lookalike/similar audiences</h3>
        <p className="text-lg text-gray-700 mb-4">
          Lawful basis of processing:
        </p>
        <p className="text-lg text-gray-700 mb-4">
          In accordance with your preferences, we may also use your personal information to provide you with information about services and promotions that may be of interest to you. This includes any of the following:
        </p>
        <ul className="list-disc pl-5 text-lg text-gray-700 mb-4">
          <li>Information that you provide when completing an online form, application, or send your details to us</li>
          <li>Information relating to any use you make of our services, including any other transaction details (including your address, telephone number and financial details)</li>
          <li>Technical information we collect about you including cookies and information about your visit to our sites, apps, and other properties.</li>
          <li>Information we collect about you from other sources such as directories, social media, third-party databases, and other companies</li>
          <li>
            Data we receive will be used for the purposes it was provided, including:
            <ul className="list-disc pl-5 mt-2">
              <li>To respond to queries about our services</li>
              <li>To provide you with information about related products and services we believe you will be interested in</li>
              <li>For our Business Partners to send you offers, promotions, information or other content we think you will be interested in</li>
              <li>To operate and grow our business</li>
              <li>
                  In relation to our Business Partners, data we receive could also be used by us to run our business, including:
                <ul className="list-disc pl-5 mt-2">
                  <li>To carry out our obligations arising from any contracts entered into between our Business Partners and us including the provision of services, and to respond to queries regarding those contracts</li>
                  <li>To manage and administer the relationships between our Business Partners and us</li>
                  <li>Develop and maintain our websites, apps, and other services</li>
                  <li>To obtain feedback about our services</li>  
                </ul>
              </li>
            </ul>
          </li>
        </ul> 

        <h2 className="text-xl font-bold mb-4 text-gray-800">Your Agreement</h2>
        <p className="text-lg text-gray-700 mb-4">
          By visiting our website, responding to our advertisements submitting your personal data on our website, app or other property or as required to provide services to you, you are confirming your agreement for your data to be used in accordance with this Privacy Policy.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          You will be able to change your preferences at any time as described in the section below - how to opt out.
        </p>

        <h2 className="text-xl font-bold mb-4 text-gray-800">How to opt out</h2>
        <p className="text-lg text-gray-700 mb-4">
          You can opt out of receiving contact from us at any time. You also have the right to request that any of your personal data is deleted at any time. Please contact us with your request.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">What are your rights?</h3>
        <p className="text-lg text-gray-700 mb-4">
          If we have collected, stored, or processed your data as part of running our business we will at all times respect your rights as an individual and ensure we meet our obligations professionally and courteously. We operate in line with EU GDPR (May 2018) data protection guidelines.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We respect your rights and will respond to any request for access to personal information and requests to delete, rectify, transfer, data and to stop processing.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We will also advise you on how to complain to the relevant authorities, namely the Information Commissioner’s Office. Any requests or objections should be made in writing to the Data Controller or you can visit our website, call, or email us to contact us to change your preferences at any time.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Under certain circumstances, you have rights under the data protection laws in relation to your personal data. These include the right to:
        </p>
        <ul className="list-disc pl-5 text-lg text-gray-700 mb-4">
          <li>Request access to your personal data</li>
          <li>Request correction of your personal data</li>
          <li>Request erasure of your personal data</li>
          <li>Object to processing of your personal data</li>
          <li>Request restriction of processing your personal data</li>
          <li>Request transfer of your personal data</li>
          <li>Right to withdraw consent</li>
        </ul> 
        <p className="text-lg text-gray-700 mb-4">
          You can see more about these rights at: &nbsp;
          <a 
            href="https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/individual-rights/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-500 hover:underline"
          >
            https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/individual-rights/
          </a>
        </p>
        <p className="text-lg text-gray-700 mb-4">
          You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">How is your data stored and processed?</h2>
        <p className="text-lg text-gray-700 mb-4">
          Your data will be collected, stored and processed in the EU only. We do not transfer your data outside the EU. Your data will generally not be stored for more than 6 months after the end of our relationship to ensure we have records of service, payments, and other interactions we have with you.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to find out more about how the processing for the new purpose is compatible with the original purpose, please email us. If we need to use your personal data for a purpose unrelated to the purpose for which we collected the data, we will notify you and we will explain the legal ground of processing.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We may be legally obliged to disclose your personal information without your knowledge to the extent that we are required to do so by law; in connection with any ongoing or prospective legal proceedings; in order to establish, exercise or defend our legal rights (including providing information to others for the purposes of fraud prevention and reducing credit risk); to any person who we reasonably believe may apply to a court or other competent authority for disclosure of that personal information where, in our reasonable opinion, such court or authority would be reasonably likely to order disclosure of that personal information.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-gray-800">Who do we share your data with?</h3>
        <p className="text-lg text-gray-700 mb-4">
          We may share your personal data with the parties set out below for the purposes described in this document:
        </p>
        <ul className="list-disc pl-5 text-lg text-gray-700 mb-4">
          <li>Service providers who provide IT and system administration services</li>
          <li>Google - Google Analytics Privacy Policy - <a 
            href="https://policies.google.com/privacy?hl=en" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-500 hover:underline"
          >https://policies.google.com/privacy?hl=en</a>
          </li>
          <li>Hotjar - To record information about visitors to our website and their journey</li>
          <li>Professional advisers including lawyers and insurers who provide consultancy</li>
          <li>Third parties to whom we sell, transfer, or merge parts of our business or our assets</li>
          <li>Third parties as required to run our business and provide our services to our Business Partners</li>
          <li>Our Business Partners, and other third-parties, who we identify when we collect your details or when you submit your information and give us consent to share your details with these companies</li>
          <li>Other software and service providers we use to provide our services</li>
          <li>We may share your data with our partners who will contact you to offer their services</li>
          <li>We are a marketing company and as such we will share your details with our Business Partners who will contact you to promote their products and services. We will ensure that our Business Partners understand their obligations under GDPR and have taken reasonable precautions to keep your data safe. We will only share your data with your consent or as you would reasonably expect. You can remove your consent at any time.
          <li>We require our Business Partners to whom we transfer your data to respect the security of your personal data and to treat it in accordance with the law. We only allow such Business Partners to process your personal data for specified purposes and in accordance with our instructions.</li>
          </li>
        </ul> 

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Energy</h2>
        {/* <p className="text-lg text-gray-700 mb-4">
          Scottish Power - You can find more details about how Scottish Power will use your data here <a 
            href="https://www.scottishpower.co.uk/legal/privacy-policy" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-500 hover:underline"
          >https://www.scottishpower.co.uk/legal/privacy-policy
          </a>
        </p> */}
        <p className="text-lg text-gray-700 mb-4">
          DWM Administration Services Limited - You can find more details about how DWM will use your data here <a 
            href="https://yourdwm.co.uk/privacy-policy/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-500 hover:underline"
          >https://yourdwm.co.uk/privacy-policy/
          </a>
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Fresh Fibre Limited - You can find more details about how Fresh will use your data here <a 
            href="https://freshfibre.co.uk/privacy-policy/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-500 hover:underline"
          >https://freshfibre.co.uk/privacy-policy/
          </a>
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Internet Advertising and Social Media Channels</h2>
        <p className="text-lg text-gray-700 mb-4">
          We use social media and internet advertising channels to collect data. Our lawful basis for this is consent and/or our legitimate interest and the legitimate interest of our Business Partners pursuant to Article 6 para. 1 lit. f of the GDPR.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We use a range of channels including:
        </p>
        <ul className="list-disc pl-5 text-lg text-gray-700 mb-4">
          <li>INSTAGRAM</li>
          <li>TABOOLA</li>
          <li>FACEBOOK</li>
          <li>OUTBRAIN</li>
          <li>GEMINI [YAHOO]</li>
          <li>BING</li>
          <li>Google [advertising and display network]</li>
        </ul>
        <p className="text-lg text-gray-700 mb-4">
          Where these companies collect, store, or process data outside of the EU we ensure appropriate safeguards are in place for example standard contractual clauses, an EU adequacy decision, or the USA Privacy Shield. For access to the Privacy Policy of these companies you should visit their home page.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Analysis and advertising tools</h2>
        <p className="text-lg text-gray-700 mb-4">
          We conduct analysis of user behaviour and website visits in order to improve our website and marketing. This is done on the basis of Art.6 1lit. f of the GDPR.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Google Analytics
        </p>
        <p className="text-lg text-gray-700 mb-4">
          This website uses Google Analytics, a web analysis service. These are operated by Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. (“Google”). In this context, Google servers are accessed in the USA. Google also complies with certain legal frameworks relating to the transfer of data, such as the European Union (EU)-US and Swiss-US Privacy Shield Frameworks. In order to effectively implement the strict European data protection requirements.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          When IP addresses are processed by Google Analytics, they are made anonymous. This means that these are usually reduced before a transmission outside the EU or the European Economic Area (EEA) and in exceptional cases immediately after the transmission there. This anonymised data is used for the purpose of analysing the use of this website and providing other services in connection with this website. The collected data will not be merged with other data held by Google.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Security</h2>
        <p className="text-lg text-gray-700 mb-4">
          We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who as a business need to know such data. They will only process your personal data on our instructions, and they are subject to a duty of confidentiality.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We will report any breaches or potential breaches to the appropriate authorities within 24 hours and to anyone affected by a breach within 72 hours. If you have any queries or concerns about your data usage, please contact us.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          This website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements. When you leave our website, we encourage you to read the privacy notice of every website you visit.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Cookies</h2>
        <p className="text-lg text-gray-700 mb-4">
          A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyse web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences. We use traffic log cookies to identify which pages are being used. This helps us analyse data about webpage traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Overall, cookies help us provide you with a better website by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Strictly Necessary Cookies</h2>
        <p className="text-lg text-gray-700 mb-4">
          These cookies are necessary for the website to function and cannot be switched off in our systems. They are set in response to actions made by the user in the website and are required to identify irregular site behaviour, prevent fraudulent activity, and improve security.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          You can set your browser to block or alert about these cookies, but some parts of the site will then not work. These cookies do not store any personally identifiable information.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Performance cookies and analytics technologies</h2>
        <p className="text-lg text-gray-700 mb-4">
          These cookies collect information about how visitors and users use our websites and services, for instance which functionality visitors use most often, and if they get error messages from areas of the websites or services. These cookies do not collect information that identifies a visitor or user. All information these cookies collect is aggregated and therefore anonymous. We only use these cookies to improve how our websites and services work.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We use third parties like Google Analytics for this purpose, for further information, please visit their privacy policy: <a 
            href="https://policies.google.com/privacy?hl=en&gl=ZZ" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-500 hover:underline"
          >https://policies.google.com/privacy?hl=en&gl=ZZ
          </a>
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Functionality cookies</h2>
        <p className="text-lg text-gray-700 mb-4">
          These cookies allow our websites and services to remember choices you make (such as your user name, language, or the region you are in) and provide enhanced, more personal features.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          These cookies can also be used to remember changes you have made to text size, fonts, and other parts of web pages that you can customise. They may also be used to provide services you have asked for. The information these cookies collect may be anonymised and they cannot track your browsing activity on other websites.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Targeting or advertising cookies</h2>
        <p className="text-lg text-gray-700 mb-4">
          These cookies are used to deliver adverts more relevant to you and your interests. They are also used to limit the number of times you see an advertisement, as well as help measure the effectiveness of the advertising campaign. They are usually placed by advertising networks with the website operator's permission. They remember that you have visited a website and this information is shared with other organisations such as advertisers. Quite often, targeting or advertising cookies will be linked to site functionality provided by the other organisation.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          For further details in how these networks process personal data, please find a link to their respective privacy policies.
        </p>
        <p className="text-lg text-gray-700 mb-4">
        Facebook Advertising: <a 
            href="https://www.facebook.com/privacy/explanation" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-500 hover:underline"
          >https://www.facebook.com/privacy/explanation</a> or visit <a 
          href="https://www.facebook.com/help/610457675797481/?helpref=hc_fnav" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-500 hover:underline"
        >https://www.facebook.com/help/610457675797481/?helpref=hc_fnav</a> to see how your data is used on Facebook Ads<br />
        Bing Ads: <a 
          href="https://privacy.microsoft.com/da-dk/privacystatement" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-500 hover:underline"
        >https://privacy.microsoft.com/da-dk/privacystatement<br />
        </a>
        Taboola Ads: <a 
          href="https://help.taboola.com/hc/en-us/articles/360004904154-Taboola-s-Trust-Center" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-500 hover:underline"
        >https://help.taboola.com/hc/en-us/articles/360004904154-Taboola-s-Trust-Center</a><br />
        Outbrain Ads: <a 
          href="https://www.outbrain.com/help/advertisers/outbrain-gdpr/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-500 hover:underline"
        >https://www.outbrain.com/help/advertisers/outbrain-gdpr/
        </a><br />
        Google Ads: <a 
          href="https://policies.google.com/privacy?hl=en&gl=ZZ" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-500 hover:underline"
        >https://policies.google.com/privacy?hl=en&gl=ZZ</a>
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Legitimate Interests</h2>
        <p className="text-lg text-gray-700 mb-4">
          We have completed a Legitimate Interest Balancing Assessment and as such we have determined that our processing is reasonable and the rights of any individual are not adversely affected. We take these rights seriously and will review this assessment regularly.
        </p>

        <h2 className="text-2xl font-bold mb-4 text-gray-800">Contacting us, exercising your information rights and Complaints</h2>
        <p className="text-lg text-gray-700 mb-4">
          If you have any questions or comments about this Privacy Policy, wish to exercise your information rights in connection with the personal data you have shared with us or wish to complain, please contact us at COMPARISON GURU LTD
        </p>
        <p className="text-lg text-gray-700 mb-4">
          Email: <a href="mailto:hello@comparison-guru.co.uk" className="text-blue-600 underline">hello@comparison-guru.co.uk</a><br/>
          Website: <a href="https://comparison-guru.co.uk" className="text-blue-600 underline">https://comparison-guru.co.uk</a>
        </p>
        <p className="text-lg text-gray-700 mb-4">
          We fully comply with Data Protection legislation and will assist in any investigation or request made by the appropriate authorities.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          If you remain dissatisfied then you have the right to apply directly to the Information Commissioner for a decision.
        </p>
        <p className="text-lg text-gray-700 mb-4">
          The Information Commissioner can be contacted at:
        </p>
        <ul className="list-disc pl-5 text-lg text-gray-700 mb-4">
          <li>Information Commissioner's Office</li>
          <li>Wycliffe House</li>
          <li>Water Lane</li>
          <li>Wilmslow</li>
          <li>Cheshire</li>
          <li>SK9 5AF</li>
          <li>www.ico.org.uk</li>
        </ul>

        <h3 className="text-lg text-gray-700 mt-8">
          <strong>COMPARISON GURU LTD</strong><br />
          <strong>Registered Office Address</strong>: 58, Coldbath Road, Birmingham, B13 0AQ.<br />
          <strong>Company number</strong>: 15447763 <br /><br/>
          Copyright © 2026 comparison-guru.co.uk
        </h3>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
